import { createApp } from 'vue';
import { createPinia } from 'pinia';
import AltoneoUI from 'altoneo-charting';

import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import './assets/main.css';

import App from './App.vue';
import { router } from './router';
import { initPreferences } from './lib/preferences';
import { surNonAuthentifie } from './lib/api';
import { useAuthStore } from './stores/auth';
import { useDecouverteStore } from './stores/decouverte';

// Thème appliqué AVANT le montage : pas de clignotement clair → sombre.
initPreferences();

const pinia = createPinia();
const app = createApp(App).use(pinia);
// Le mode démo est relu AVANT le routeur : sa première garde appelle `/me`,
// qui doit déjà partir vers le bon monde (données fictives ou vraies).
useDecouverteStore(pinia).hydrater();
app.use(router).use(AltoneoUI);

/*
 * SESSION EXPIRÉE en cours de travail (cookie de 8 h) : on renvoie à la
 * connexion en gardant l'adresse, pour revenir au même écran après. Sans cela,
 * chaque appel échouerait en « non authentifié » sans que rien ne bouge.
 */
surNonAuthentifie(() => {
  const auth = useAuthStore(pinia);
  auth.user = null;
  const courant = router.currentRoute.value;
  if (courant.name !== 'login') {
    void router.replace({ name: 'login', query: { redirect: courant.fullPath } });
  }
});

app.mount('#app');
